module.exports = __webpack_public_path__ + "img/share-icon.0f4a0cd2.svg";